export default {
  welcomes: '欢迎来到后台，请选择左边其它菜单栏',
  rules: {
    username: '账号不能为空！',
    password: '密码不能为空！',
    code: '验证码不能为空！'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/login.js